import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../core/common';
import { IGetSampleProductOrderHeader, ISampleProductOrderHeader, ISampleProductOrderDetails, IGetDiscountStoreOrderHeader, IDiscountStoreOrderHeader } from '../../../../../core/models';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { DiscountStoreService } from '../../../../../core/services/discount-store.service';
@Component({
  selector: 'app-order-history',
  templateUrl: './order-history.component.html',
  styleUrls: ['./order-history.component.scss']
})
export class OrderHistoryComponent implements OnInit {
  filterOrderHeaderForm: FormGroup;
  filterSaveInProcess: boolean;
  orderHeaderGridData: GridDataResult;
  orderGridData: IDiscountStoreOrderHeader[] = [];
  orderLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  filterValidateMessage: boolean;
  //#region label declaration  

  public orderLblText = {
    contactLbl: 'Contact',
    customerLbl: 'Customer',
    ccEmailLbl: 'CC Email',
    regionLbl: 'Region',
    createdDateLbl: 'Order Date',
    sampleProductOrderNumberLbl: 'Order Number',
    costLbl: 'Cost',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Product',
    startDateLbl: 'Start Date',
    endDateLbl: 'End Date',
    filterInfoMsgLbl: 'Please Select Start Date and End Date',
    filterButtonLbl: 'Filter'
  };
  //#endregion
  loadOpenOrders: boolean = true;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private appNotifyService: AppNotifyService,
    private commonService: CommonService,
    private cp: CurrencyPipe,
    private discountStoreService: DiscountStoreService,
    private productSampleFulfillmentService: ProductSampleFulfillmentService //delete it
  ) {
    console.log(this.router.url);
    if (this.router.url.indexOf('view-clearance-store-order-history') > -1) {
      this.loadOpenOrders = false;
    }
  }

  ngOnInit() {
    this.initializeData();
  }
  initializeData() {
    this.getLoadOpenOrders();
  }

  public orderGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public orderGridSettings: GridSettings = {
    state: this.orderGridstate,
    gridData: process(this.orderGridData, this.orderGridstate),
    columnsConfig: [
      {
        field: 'OrderHeaderId',
        title: 'Order Id',//this.orderLblText.sampleProductOrderNumberLbl,
        filterable: true,
        widthForPDF: 80,
        _width: 150,
        hidden: true,
      },
      {
        field: 'orderNumber',
        title: 'Order #',//this.orderLblText.sampleProductOrderNumberLbl,
        filterable: true,
        widthForPDF: 80,
        _width: 120,
      },
      {
        field: 'billToCustomerNumber',
        title: 'Customer #',//this.orderLblText.customerLbl,
        filterable: true,
        widthForPDF: 100,
        _width: 120,
      },
      {
        field: 'billToCustomerName',
        title: 'Customer Name',//this.orderLblText.customerLbl,
        filterable: true,
        widthForPDF: 100,
        _width: 220,
      },
      {
        field: 'orderDate',
        title: 'Received Date',//this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderSelectionGridLbl.orderDatelbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 120,
        filterable: false,
        widthForPDF: 80,
      },
      {
        field: 'requestDate',
        title: 'Request Date',//this.orderlblText.orderDatelbl ? this.orderlblText.orderDatelbl : this.orderSelectionGridLbl.orderDatelbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 120,
        filterable: false,
        widthForPDF: 80,
      },
      {
        field: 'jobName',
        title: 'Job Name',//this.orderLblText.contactLbl,
        //_width: 200,
        filterable: true,
        widthForPDF: 100,
        _width: 150,
      },
      {
        field: 'userEmailId',
        title: 'Contact',//this.orderLblText.contactLbl,
        //_width: 200,
        filterable: true,
        widthForPDF: 100,
        _width: 220,
      },
      {
        field: 'shipToCity',
        title: 'Shipping Location',//this.orderLblText.contactLbl,
        //_width: 200,
        filterable: true,
        widthForPDF: 100,
        _width: 150,
      }
    ]
  };


  async getLoadOpenOrders() {
    this.orderLoading = true;
    let d;
    if (this.loadOpenOrders) {
      d = await this.discountStoreService.getOpenOrders().toPromise();
    }
    else {
      d = await this.discountStoreService.getCompletedOrders().toPromise();
    }
    this.orderGridData = d;
    this.bindOrderHeaderGridData();
    this.orderLoading = false;
  }
  //#region Grid Ops
  public bindOrderHeaderGridData(): void {
    if (this.orderGridSettings.state)
      this.orderHeaderGridData = process(this.orderGridData, this.orderGridSettings.state);
    else
      this.orderHeaderGridData = process(this.orderGridData, this.orderGridstate);
    this.orderGridSettings.gridData = this.orderHeaderGridData;
  }
  public orderHeaderGridSortChange(sort): void {
    this.orderGridstate.sort = sort;
    this.bindOrderHeaderGridData();
  }

  public orderHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.orderGridstate.skip = skip;
    this.orderGridstate.take;
    this.bindOrderHeaderGridData();
  }

  public orderHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.orderGridstate = state;
    this.orderGridSettings.state = this.orderGridstate;
    this.bindOrderHeaderGridData();
  }
  //#endregion

  proceedToOrderDetails(dataItem: IDiscountStoreOrderHeader) {
    this.discountStoreService.setSingleDiscountOrderHeaderGridData(dataItem);
    this.router.navigate(['discount-store/admin/order-history/order-details/' + dataItem.orderNumber]);
  }

}
